import React from 'react'
import PropTypes from 'prop-types'

const EventTime = ({ startDateString, timeString }) => (
  <div className="flex flex-col justify-between items-center h-12 text-lg">
    <p className="font-bold text-white w-full m-0">{startDateString}</p>
    <p className="text-white w-full m-0">{timeString}</p>
  </div>
)

EventTime.propTypes = {
  startDateString: PropTypes.string,
  timeString: PropTypes.string,
}

export default EventTime
